import React from "react";
import { Badge, BadgeColor, depascalize } from "sprint-common-web";

import { AssetType } from "../types/AssetType";

export const AssetTypeBadge = (props: { value?: number; testId?: string }): JSX.Element => {
    return (
        <Badge
            color={mapAssetTypeToBadgeColor(props.value)}
            text={props.value ? depascalize(AssetType[props.value]) : "-"}
            testId={props.testId}
        />
    );
};

const mapAssetTypeToBadgeColor = (recordType?: AssetType): number => {
    switch (recordType) {
        case AssetType.Cloud:
            return BadgeColor.LightGreen;
        case AssetType.OnPrem:
            return BadgeColor.Blue;
        default:
            return BadgeColor.Gray;
    }
};
